module.exports = __webpack_public_path__ + "img/33.2509b85b.jpg";